import store from "@store";

export function cancelRequestAll() {
  const requestList = store.state.requestList || [];
  requestList.forEach(item => item.source(item.id));
}

export function cancelRequest(api) {
  const requestList = store.state.requestList || [];
  requestList.filter(item => item.api === api).forEach(item => item.source(item.id));
}